import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ badge: { pill }, spacing, typography }: ComposedTheme) => ({
  removeButton: {
    '& svg': { fill: pill.color, position: 'relative', width: 12 },
  },
  root: {
    ...typography.xtraSmallText,
    alignItems: 'center',
    backgroundColor: pill.backgroundColor,
    borderRadius: 30,
    color: pill.color,
    display: 'inline-flex',
    padding: [spacing.unit / 2, spacing.unit, spacing.unit / 2, spacing.unit],
    whiteSpace: 'nowrap',
  },
});

export default createUseStyles(styles);
